<template>
    <span class="Controls">
        {{value.value}}
    </span>
</template>

<script>
export default {
    name: 'Controls',
    props: {
        value: {
            type: Object,
            default: function () {
                return {
                    value: ''
                }
            }
        }
    },
    data() {
        return {
        }
    },
    created() {
    },
    methods: {
    },
    watch: {
    },
    components: {
    }
}
</script>
